import { render, staticRenderFns } from "./teamBuilding.vue?vue&type=template&id=18a43995&scoped=true"
import script from "./teamBuilding.vue?vue&type=script&lang=js"
export * from "./teamBuilding.vue?vue&type=script&lang=js"
import style0 from "./teamBuilding.vue?vue&type=style&index=0&id=18a43995&prod&scoped=scoped&lang=scss"
import style1 from "./teamBuilding.vue?vue&type=style&index=1&id=18a43995&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18a43995",
  null
  
)

export default component.exports